import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Loader: React.FunctionComponent<Props> = (props) => {
  const { size = 104, ...restProps } = props;
  return (
    <svg
      {...restProps}
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 104 104'
      fill='none'>
      <path
        fill='currentColor'
        d='M4.501 44.417c-2.127-.34-4.141 1.11-4.32 3.256A52 52 0 1 0 55.663.13c-2.149-.152-3.89 1.618-3.88 3.771.01 2.154 1.767 3.875 3.913 4.055a44.2 44.2 0 1 1-47.789 40.95c.151-2.148-1.28-4.148-3.407-4.488Z'
      />
    </svg>
  );
};

export default Loader;
